import React from 'react';
import { createRoot } from 'react-dom/client';
import Attribution from './Attribution';
import EmbedRoot from './EmbedRoot';
import registry from './registry';
import { findTargets, parseConfig, widgetNameFromElement } from './bootstrapUtils';

// An expando rather than an attribute: invisible to the host page's CSS and
// JS, and it cannot be cleared by markup being re-rendered around it.
const MOUNTED = '__omnigoMounted';

const mountElement = (el) => {
    if (!el || el[MOUNTED]) {
        return;
    }

    const name = widgetNameFromElement(el);
    const Widget = registry[name];

    if (!Widget) {
        console.warn(
            `omnigo: no widget named ${JSON.stringify(name)}.`,
            `Known widgets: ${Object.keys(registry).join(', ')}.`,
            el
        );
        return;
    }

    el[MOUNTED] = true;
    createRoot(el).render(
        <EmbedRoot container={el} attribution={<Attribution />}>
            <Widget {...parseConfig(el.dataset)} />
        </EmbedRoot>
    );
};

const mount = (root = document) => {
    findTargets(root).forEach(mountElement);
};

/**
 * Mounts every widget on the page, now or once the DOM is parsed.
 *
 * Covers the script being loaded before its target div (`defer`, or a tag in
 * `<head>`) as well as after it.
 */
const autoMount = () => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => mount());
        return;
    }
    mount();
};

export {
    mount,
    mountElement,
    autoMount
};
